import {createModel} from '@@/package/utils/ModelUtil';
import Model from "~~/package/mapper/Model";

/** 설문 항목 한 개의 답변. questionId 는 GA 노출 시 사용할 안정적 키. */
export interface SurveyAnswerModel {
    questionId: string;
    type: string;
    value: number | string | string[] | null;
}

/** 설문 제출 요청 모델. (user 식별 데이터는 서버에서 채우므로 포함하지 않는다) */
export class SurveyResponseModel extends Model {
    constructor(
        public surveyId: string = "",
        public surveyName: string = "",
        public version: string = "",
        public page: string = "",
        public locale: string = "",
        public assessmentId: number | null = null,
        public answers: SurveyAnswerModel[] = []
    ) {
        super();
    }

    public static create(model: Partial<SurveyResponseModel>): SurveyResponseModel {
        return createModel<SurveyResponseModel>(SurveyResponseModel, {
            ...model
        });
    }
}
